import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, role, allowWithoutTnc = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="font-heading text-2xl text-deep tracking-tight">Cozy Heaven…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/student"} replace />;
  }
  if (
    user.role === "student" &&
    !user.tnc_accepted_at &&
    !allowWithoutTnc &&
    location.pathname !== "/student/consent"
  ) {
    return <Navigate to="/student/consent" replace />;
  }
  return children;
}
